var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('hr'),_c('p',{attrs:{"id":"copyrights"}},[_vm._v("\n    2019 Copyrights All Reserved ioi.\n  ")])])}]

export { render, staticRenderFns }